import React from 'react';
import { Switch } from 'antd';
import 'antd/dist/antd.css';

const Toggle = ({ checked, onChange,checkedLabel,unCheckedLabel }) => {
  return (
    <Switch
    checked={checked}
      onChange={onChange}
      checkedChildren={checkedLabel}
      unCheckedChildren={unCheckedLabel}
   className='bg-tripplo-200 '
/>
  )
};
export default Toggle
